import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { Overview } from 'modules/trainings/components/Revamp/MyTrainings/Overview'

const MyTrainingsOverview = () => (
  <ResponsivePage.Body variant="full">
    <Overview />
  </ResponsivePage.Body>
)

export default MyTrainingsOverview
